import scroll from "scroll-into-view";

export const scrollIntoView = (element) => {
	scroll(element, SCROLL_INTO_VIEW_SETTINGS);
};

const SCROLL_INTO_VIEW_SETTINGS = {
	time: 1500,
	align: {
		top: 0
	}
};



// WEBPACK FOOTER //
// ./src/utils/ScrollIntoView.js